<div class="d-my-health">
	<div class="d-title-holder">
		<h2 [translate]="'dashboard.health-panel.title'">My Health Coaching</h2>
		<span>
			<a
				[routerLink]="['/health/mentor']"
				*ngIf="isMatchedMember"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/health/mentor',
					componentName: 'health-panel',
					id: 'Dashboard health panel Coaching',
					placement: 'Dashboard health panel'
				}">
				<i class="fa fa-angle-right"></i>
			</a>
		</span>
	</div>
	<div class="d-my-health-content">
		<p [translate]="'dashboard.health-panel.description'">
			Discover how our personalized care can transform the way you feel.
		</p>

		<ul class="d-my-health-i">
			<li *ngFor="let category of categories" [ngClass]="category === selectedCategory ? 'active' : ''">
				<p>{{ category.title }}</p>
				<div class="d-s-placeholder" (click)="selectedCategory = category">
					<div
						class="d-h-m-svg-conatiner"
						[innerHTML]="renderSVG(category.svg)"
						[ngClass]="category === selectedCategory ? 'active-category-img' : ''"></div>
				</div>
			</li>
		</ul>

		<p>{{ selectedCategory?.note }}</p>
		<div class="d-carousel">
			<ng-container [ngSwitch]="true">
				<button
					[routerLink]="['/health/mentor']"
					appEheAnalytics
					[data]="{
						pageUrl: '/dashboard',
						redirectedTo: '/health/mentor',
						componentName: 'health-panel',
						id: 'Dashboard health panel schedule coach',
						placement: 'Dashboard health panel'
					}"
					*ngIf="panelStatus?.healthPanel === 'ELIGIBLE_FOR_MENTOR'"
					mat-stroked-button
					class="button center"
					[ngClass]="isMatchedMember ? '' : 'disabled-button'">
					<span [translate]="'dashboard.health-panel.schedule-coach-button'">Schedule a coach</span>
				</button>
			</ng-container>
		</div>

		<div
			class="row exam-warming-overlay"
			*ngIf="
				panelStatus?.healthPanel === 'NON_MATCHED' ||
				panelStatus?.healthPanel === 'SCHEDULE_PE' ||
				panelStatus?.healthPanel === 'MENTOR_NOT_ELIGIBLE'
			">
			<p [translate]="'dashboard.health-panel.physical-exam-complete'">
				After completing your EHE exam, you become eligible for one-on-one sessions with a Health Coach.
			</p>
			<button
				*ngIf="panelStatus?.healthPanel === 'SCHEDULE_PE'"
				[routerLink]="['/scheduling']"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/scheduling',
					componentName: 'health-panel',
					id: 'Dashboard health panel schedule coach',
					placement: 'Dashboard health panel'
				}"
				mat-stroked-button
				class="button center">
				<span [translate]="'dashboard.health-panel.schedule-exam-button'">Schedule an Exam</span>
			</button>
		</div>
	</div>
</div>
